// @flow

import styled from 'styled-components';

import { theme } from '../theme';

export const SectionTitle = styled.h2`
  font-family: ${theme.fontFamily.display};
  text-align: center;
  font-weight: 500;
  font-size: 1.4em;
  color: hsla(0,0%,40%,1);
`;

export const SectionSubtitle = styled.p`
  text-align: center;
  font-size: 1em;
`;
